import React, { FC } from 'react';
import { motion } from 'framer-motion';
import { HStack } from '@montel/montelpro-shared-components-v2';
import { MenuItemProps } from '../menuTypes';
import { useMenuContext } from '../menuContext';
import {
	StyledListItem,
	StyledTopMenuItem,
	StyledUnderline,
	StyledVStack,
} from './TopMenuItem.styles';

const TopMenuItem: FC<MenuItemProps> = ({
	text,
	icon,
	link,
	className,
	...otherProps
}) => {
	const ItemIcon = icon;
	const { isActive } = useMenuContext();

	return (
		<StyledListItem>
			<StyledTopMenuItem
				$isActive={isActive}
				className={className}
				to={link}
				{...otherProps}
			>
				<StyledVStack justify="center">
					<HStack align="center">
						{ItemIcon}
						{text}
					</HStack>
					<StyledUnderline
						as={motion.div}
						layout
						$active={isActive}
					/>
				</StyledVStack>
			</StyledTopMenuItem>
		</StyledListItem>
	);
};

export default TopMenuItem;
